import { render } from "./ResourcePageHeader.vue?vue&type=template&id=4c600614"
import script from "./ResourcePageHeader.vue?vue&type=script&lang=js"
export * from "./ResourcePageHeader.vue?vue&type=script&lang=js"

import "./ResourcePageHeader.vue?vue&type=style&index=0&id=4c600614&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__